import React, { memo } from 'react'
import over from 'ramda/src/over'
import lensPath from 'ramda/src/lensPath'
import not from 'ramda/src/not'
import map from 'ramda/src/map'
import filter from 'ramda/src/filter'
import findIndex from 'ramda/src/findIndex'
import propEq from 'ramda/src/propEq'
import assoc from 'ramda/src/assoc'
import when from 'ramda/src/when'
import equals from 'ramda/src/equals'
import pipe from 'ramda/src/pipe'
import path from 'ramda/src/path'
import withStyles from '@material-ui/core/styles/withStyles'
import CheckboxButton from 'root/src/client/web/base/CheckboxButton'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import ToolTipWraper from 'root/src/client/web/base/TooltipWraper'

const styles = {
	multipleChoiceContainer: {
		display: 'flex',
		alignItems: 'center',
		[ltGtMediaQuery]: {
			flexDirection: 'column',
			justifyContent: 'center',
			marginBottom: 15,
		},
	},
	optionsContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		[ltGtMediaQuery]: {
			flexFlow: 'wrap',
		},
	},
}

const HeadlessOption = ({
	id,
	component: Component,
	color,
	active,
	tooltip,
	onChange,
}) => (
	<Component
		id={id}
		color={color}
		active={active}
		tooltip={tooltip}
		onChange={onChange}
	/>
)

const MultipleChoiceEmbeded = memo(({
	classes, options, label: headerLabel, handler, showTooltips, tooltipHeader,
}) => {
	const handleOptionChange = (optionId) => {
		const activeOptions = filter(propEq('active', true), options)
		if (activeOptions.length === 1 && optionId === path([0, 'id'], activeOptions)) {
			return handler(map(assoc('active', true), options))
		}
		const newOptions = pipe(
			when(
				() => equals(activeOptions.length, options.length),
				map(assoc('active', false)),
			),
			over(lensPath([findIndex(propEq('id', optionId), options), 'active']), not),
		)(options)
		return handler(newOptions)
	}
	const Wrapper = showTooltips ? ToolTipWraper : React.Fragment

	return (
		<div className={classes.multipleChoiceContainer}>
			<Typography variant={typographyVariants.mini}>
				{headerLabel}
			</Typography>
			<div className={classes.optionsContainer}>
				{map(({ id, label, color, active, tooltip }) => (
					<Wrapper
						key={id}
						tooltipHeader={tooltipHeader}
						tooltipText={tooltip}
					>
						{typeof label === 'function' ? (
							<HeadlessOption
								id={id}
								color={color}
								active={active}
								component={label}
								onChange={handleOptionChange}
								tooltip={tooltip}
							/>
						)
							: (
								<CheckboxButton
									{...{
										id,
										label,
										color,
										key: id,
										checked: active,
										onClick: () => handleOptionChange(id),
									}}
								/>
							)}
					</Wrapper>
				), options)}
			</div>
		</div>
	)
})

export default memo(withStyles(styles, { name: 'MuiMultipleChoiceEmbeded' })(MultipleChoiceEmbeded))
